import { Decimal } from 'decimal.js'
import AvatarDefault from 'assets/img/spot/avatar-default.jpg'

// 成本 委托数量*成交均价=成本
export function onCost(buyDelegateCount: string, buyPrice: string) {
    return new Decimal(buyPrice).times(buyDelegateCount)
}
// 当前总额 当前价*成交数量=当前总额
export function onAmount(price: string, dealCount: string) {
    return new Decimal(price).times(dealCount)
}
// 收益率
export function onRoeText(cost: Decimal, amount: Decimal) {
    let earnings = amount.sub(cost)
    let priceDiffNum = earnings.div(cost)
    if (priceDiffNum.greaterThan(0)) {
        return priceDiffNum.toFixed(4, Decimal.ROUND_DOWN)
    }
    return priceDiffNum.toFixed(4, Decimal.ROUND_UP)
}

//价格计算收益率
export function calRateOfReturn(
    price: any,
    buyDealCount: any,
    buyPrice: any,
    buyDelegateCount: any
) {
    if (!price) return 0
    let amount = new Decimal(price).times(buyDealCount)
    let cost = new Decimal(buyPrice).times(buyDelegateCount)
    let earnings = amount.sub(cost)
    let priceDiffNum = earnings.div(cost).times(100)
    return priceDiffNum.toFixed(0)
}

// 止盈比 计算 值
/*** 收益率 当前总额-成本=收益，收益/成本=收益率
 * 当前价*成交数量=当前总额
 * 成本 = 委托数量*成交均价
 * 价格 = (收益率 / 100 +1) * 成本 / 成交数量
 */
export function calcTakeProfitPlanPrice(
    newPercent = 0,
    buyPrice: any,
    buyDelegateCount: any,
    buyDealCount: any,
    delegatePricePlace: any
) {
    let cost = new Decimal(buyPrice).times(buyDelegateCount)
    let percent = new Decimal(newPercent)
    percent = percent.div(100)
    percent = percent.add(1)
    percent = percent.times(cost).div(buyDealCount)

    return percent.toFixed(delegatePricePlace, Decimal.ROUND_UP)
}
/***
 * 止损百分比计算 止损价格
 *
 */
export function calcStopLossPlanPrice(
    newPercent = 0,
    buyPrice: any,
    buyDelegateCount: any,
    buyDealCount: any,
    delegatePricePlace: any
) {
    let cost = new Decimal(buyPrice).times(buyDelegateCount)
    let percent = new Decimal(0)
    percent = percent.sub(newPercent) //止损百分比应为负值，滑杆传入的值为正值
    percent = percent.div(100).add(1)
    percent = percent.times(cost).div(buyDealCount)

    return percent.toFixed(delegatePricePlace, Decimal.ROUND_DOWN)
}
/**
 * 计算未实现盈亏收益率 格式
 *
 */
// 收益率 当前总额-成本=收益，收益/成本=收益率
export function onRoe(cost: Decimal, amount: Decimal, quotePrecision: number) {
    let earnings = amount.sub(cost)
    let decimalProfits = earnings.div(cost)
    let priceDiffNum = ''
    if (decimalProfits.greaterThan(0)) {
        priceDiffNum = decimalProfits.toFixed(4, Decimal.ROUND_DOWN)
    } else {
        priceDiffNum = decimalProfits.toFixed(4, Decimal.ROUND_UP)
    }

    decimalProfits = new Decimal(priceDiffNum)
    let itemObj = {
        color: '',
        addFlag: '',
        roeText: '',
        earnings: ''
    }
    let color = ''
    let addFlag = ''
    if (decimalProfits.greaterThan(0)) {
        addFlag = '+'
        color = 'colored-text__rise'
        itemObj.earnings = earnings.toFixed(quotePrecision, Decimal.ROUND_DOWN)
    } else {
        decimalProfits.isZero() ? (color = '') : (color = 'colored-text__fall')
        itemObj.earnings = earnings.toFixed(quotePrecision, Decimal.ROUND_UP)
    }
    let roe = decimalProfits.times(100) //收益率百分比
    itemObj.color = color
    itemObj.addFlag = addFlag
    itemObj.roeText = addFlag + roe.toFixed(2, Decimal.ROUND_DOWN) + '%'

    return itemObj
}
export function clearNoNum(val, num) {
    num = num === undefined ? 8 : num
    let newVal = val.toString()
    newVal = newVal.replace(/[^\d.]/g, '') // 清除“数字”和“.”以外的字符
    newVal = newVal.replace(/^\./g, '') // 验证第一个字符是数字而不是.
    newVal = newVal.replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
    if (num == 0) {
        newVal = newVal.replace(/\./g, '') // 不要小数点
    }
    newVal = newVal.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
    newVal = newVal.replace(new RegExp('^(\\-)*(\\d+)\\.(\\d{0,' + num + '}).*$', 'gmi'), '$1$2.$3')
    return newVal
}

// 占位图
export function defaultAvatorImg(url: any) {
    if (url) {
        return url
    }
    return AvatarDefault
}

// 汇总数据计算
export function summaryCalMix(orders: any) {
    let itemObj = { ...orders[0] }
    // 委托数量*成交均价=成本 ， 当前价*成交数量=当前总额， 当前总额-成本=收益，收益/成本
    let cost = new Decimal(0) //成本
    let amount = new Decimal(0) // 当前总额
    let count = new Decimal(0) // 总数量
    let dealCountTotal = new Decimal(0) // 总成交数量
    itemObj.orderNo = []
    orders.forEach((item: any) => {
        itemObj.orderNo.push(item.orderNo)
        let itemCost = onCost(item.buyDelegateCount, item.buyPrice)
        cost = cost.add(itemCost) //总成本累加
        let itemAmount = onAmount(itemObj.marketPrice, item.dealCount || item.buyDealCount)
        amount = amount.add(itemAmount) //总金额累加
        count = count.add(item.buyDelegateCount) // 总数量累加
        dealCountTotal = dealCountTotal.add(item.holdCount) // 数量累加
    })
    itemObj.dealCountTotal = dealCountTotal.toString()
    // 是否有带单，有带单则不显示结束按钮
    let trackingType = orders.some(item => item.trackingType == 0)
    itemObj.trackingType = trackingType ? 0 : 1

    let average = cost.div(count).toFixed(itemObj.pricePlace, Decimal.ROUND_UP) //汇总均价
    itemObj.buyPrice = average

    let decimalProfits = Object.assign({}, onRoe(cost, amount, itemObj.quotePrecision))

    return { ...itemObj, ...decimalProfits }
}
